import { PLATFORM_BATCH_PAGE } from '@constants/segment';
import {
  getIsBatchAccessEnded,
  getIsBatchCompleted,
  getMessageWithDate
} from '../utils';
import BatchStatusCard from '../BatchStatusCard';
import PlatformBatchHeader from '../PlatFormBatchHeader';

// {/* batch access end , batch end card, detail card (without price and join button) */}

const EnrolledBatchState = ({ batchDetails, entitySubType }) => {
  const { batchExpiryDate, completedAt } = batchDetails;
  const isBatchAccessEnded = getIsBatchAccessEnded(batchExpiryDate);
  const isBatchCompleted = getIsBatchCompleted(completedAt);
  if (isBatchAccessEnded) {
    return (
      <BatchStatusCard
        imageUrl="prodigy/enrollment-date-end.svg"
        title="Your access to this batch has ended"
        subTitle={getMessageWithDate('Ended on ', batchExpiryDate)}
      />
    );
  }
  if (isBatchCompleted) {
    return (
      <BatchStatusCard
        imageUrl="prodigy/batch-end.svg"
        title={getMessageWithDate('Batch ended on', completedAt)}
        subTitle={getMessageWithDate('Your access ends', batchExpiryDate)}
      />
    );
  }
  return (
    <PlatformBatchHeader
      isStickyCard
      batchGroupUID={batchDetails.uid}
      lastPrimarySourceSection={`${PLATFORM_BATCH_PAGE} - Batch Price Card`}
      entitySubType={entitySubType}
    />
  );
};
export default EnrolledBatchState;
